import React, { Component } from 'react'
import Table from '@common/Table'
import store from './store'
import columns from './column'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    store.id = props.id
  }
  render() {
    return <Table store={store} columns={columns} rowKey="id" />
  }
}
